import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    minWidth: 780,
    hover: false, // true or false
    hoveredCard: false, // card data or false,
    lastCardTitle: '',
    lastCardColor: '#FFFFFF',
    cursorCTA: '',
    fixCursor: false,
    inDarkPage: false,
    loaderIsVisible: true,
    forceLightMinimap: false,
    colors: {
      light: '#FFFFFF',
      dark: '#000000',
      accent: '#FFA2A2'
    },
    cards: [],
    decorations: [],
    megaCanvas: {
      camera: {},
      renderer: {}
    }
  },
  mutations: {
    loaderDone (state) { state.loaderIsVisible = false },
    hoverOnCard (state, card) {
      state.hoveredCard = card
      state.hover = !!card
      if (card) {
        state.lastCardTitle = card.title
        state.lastCardColor = card.titleColor
      }
    },
    hover (state, val) { state.hover = val },
    setCards (state, cards) { state.cards = cards },
    setDecorations (state, decorations) { state.decorations = decorations },
    setMegaCanvas (state, { camera, renderer }) { state.megaCanvas = { camera, renderer } },
    setCursorCTA (state, val) { state.cursorCTA = val },
    fixCursor (state, fix) { state.fixCursor = fix },
    inDarkPage (state, invert) { state.inDarkPage = invert },
    forceLightMinimap (state, val) { state.forceLightMinimap = val }
  },
  getters: {
    lightHeader: state => state.inDarkPage ? !state.hoveredCard : state.hoveredCard
  }
})
